export function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', async () => {
    const enabled = String(process.env.REACT_APP_ENABLE_SERVICE_WORKER || '').toLowerCase() === 'true';

    if (!enabled) {
      try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map((registration) => registration.unregister()));

        if (window.caches) {
          const keys = await window.caches.keys();
          await Promise.all(
            keys
              .filter((key) => key.startsWith('damyar-'))
              .map((key) => window.caches.delete(key))
          );
        }
      } catch (error) {
        console.error('Service worker cleanup failed:', error);
      }
      return;
    }

    navigator.serviceWorker.register('/service-worker.js').catch((error) => {
      console.error('Service worker registration failed:', error);
    });
  });
}
